<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
        <div class="col-md-6 mb-2">
            <div class="pagetitle">
                <div class="btn-group-justified btn-group" style="float: right;">
                    <button (click)="nuevo()" class="btn btn-success"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
                    <!-- <button (click)="onBtnExport()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-download"></i> Download CSV </button>
                    <button (click)="copy()" class="btn btn-warning"> <i aria-hidden="true" class="fa fa-copy"></i> Copy </button>-->
                </div>
            </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  

    <ng-template #enviarTemplateEdit>
        <!-- GRILLA -->
            <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
            <br>
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                                [id]    ="DAT_AG_GRID.id" 
                                [class] ="DAT_AG_GRID.class" 
                                [ngStyle]="DAT_AG_GRID.style" 
                                [rowData]="rowData" 
                                [rowSelection] = 'rowSelection'
                                [columnDefs]="columnDefs"
                                [pagination]="DAT_AG_GRID.pagination" 
                                [paginationPageSize]="DAT_AG_GRID.pagina"
                                [defaultColDef]="defaultColDef"
                                [suppressExcelExport]="true"
                                
                                [copyHeadersToClipboard]=" true"
                                [enableRangeSelection]=" true"
                                
                                [frameworkComponents]="frameworkComponents" >
            </ag-grid-angular>
            <!--[sideBar]="true" [allowContextMenuWithControlKey]="true"  [copySelectedRows]="true"-->
        <!-- GRILLA -->
    </ng-template>
  </div>
  
    <!-- MODAL -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>
  
    <ng-template #abrirModal>
        <div class="container-fluid">
        <form [formGroup]="formulario" novalidate class="form-group">
            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="idArea" [label]="'ID AREA '" [id]="'idArea'" 
                    [control]="formulario.get('idArea')" [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Tipo de Area'" formControlName="tipoArea" [control]="formulario.get('tipoArea')" 
                                        [comboBox]="cmbxTipoArea" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Seleccione Centro Destino'" formControlName="centro" [control]="formulario.get('centro')" 
                                        [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="descArea" [label]="'* Detalle Nombre'" [id]="'descArea'" 
                    [control]="formulario.get('descArea')" [placeholder]="'Nombre del Area'" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="nomeclatura" [label]="'Nomeclatura única'" [id]="'nomeclatura'" 
                    [control]="formulario.get('nomeclatura')" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <!-- <label for="head">Seleccione Color</label>
                    <input type="color" id="color" name="color" value="#FFFFFF" formControlName="color" [control]="formulario.get('color')" /> -->
                    <app-lfsa-input formControlName="color" [label]="'*Color del Area'" [id]="'color'" class="form-control-sm"
                        [control]="formulario.get('color')" [type]="'color'" class="form-control" value="#FFFFFF">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="capacidadTotal" [label]="'*Capacidad total'" [id]="'capacidadTotal'" [control]="formulario.get('capacidadTotal')" 
                    [type]="'number'" class="form-control-sm">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="disponibilidad" [label]="'Disponibilidad Calculada'" [id]="'disponibilidad'" [control]="formulario.get('disponibilidad')" 
                     [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
            </div>

            <div class="row border border-danger rounded mb-3">
                <div class="m-2 border-bottom">Solo para excepciones</div>
                <div class="col">
                    <app-lfsa-input formControlName="capacidadExcepcion" [label]="' Capacidad Excepción'" 
                    [id]="'capacidadExcepcion'" [control]="formulario.get('capacidadExcepcion')" 
                    [type]="'number'" class="form-control-sm">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <label for="fechaInicio" style="font-size: .875rem;">Fecha y hora Inicio Excepción</label>
                    <input autocomplete="off" class="form-control" formControlName="fechaInicio" 
                    id="fechaInicio" name="fechaInicio" type="datetime-local" min="2025-01-01T00:00" max="2030-12-31T00:00" />
                    <small *ngIf="this.formulario.get('fechaInicio')?.hasError('required') && this.formulario.get('fechaInicio').touched" 
                    class="text-danger">*Campo obligatorio</small>
                </div>
                <div class="col">
                    <label for="fechaFin" style="font-size: .875rem;">Fecha y hora Fin Excepción</label>
                    <input autocomplete="off" class="form-control" formControlName="fechaFin" 
                    id="fechaFin" name="fechaFin" type="datetime-local" min="2025-01-01T00:00" max="2030-12-31T00:00" />
                    <small *ngIf="this.formulario.get('fechaFin')?.hasError('required') && this.formulario.get('fechaFin').touched" 
                    class="text-danger">*Campo obligatorio</small>
                </div>
            </div>

            <div class="row">
                Control del Registro
                <hr>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Estado'" formControlName="estado" [control]="formulario.get('estado')" [habilitar]="true" 
                    [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="creadoPor" [label]="'* Creado por'" [id]="'creadoPor'" [control]="formulario.get('creadoPor')" 
                    [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="modificadoPor" [label]="'* Modificado por'" [id]="'modificadoPor'" [control]="formulario.get('modificadoPor')" 
                    [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
            </div>
            
            <app-lfsa-botones-formulario
                (devolverAccion) ="acciones($event)" 
                [formularioValido] ="formulario.invalid"
                [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
            </app-lfsa-botones-formulario>

        </form>
        </div>

    </ng-template>
    <!-- END MODAL --> 